/* eslint-disable no-undef */
import React, {  } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
// routes
import { ToastContainer } from 'react-toastify';
import Routers from './routes';
import UserRoutes from './UserRouters'

// theme
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import PageMetaSync from './components/seo/PageMetaSync';
import AnalyticsRouteGuard from './components/analytics/AnalyticsRouteGuard';
import LoginPage from './pages/LoginPage';
import 'react-toastify/dist/ReactToastify.css';
import ThemeProvider from './theme';
import LandingPage from './pages/landingpage/landingpage';
import ExclusiveLeadsPage from './pages/landingpage/exclusiveleadpage';
import ConsumerEngagementPage from './pages/landingpage/consumerengagementpage';
import BranchLocations from './pages/states/BranchLocations';
import Florida from './pages/states/Florida';
import JohnDoe from './pages/Agents/JohnDoe';
import ClientAcquisitionPage from './pages/landingpage/clientacquisitionpage';
import PortfolioRetentionPage from './pages/landingpage/portfolioretentionpage';
import RegisterPage from './pages/RegisterPage';
import CreateLOPage from './pages/Agents/CreateLOPage';
import HomePage from './pages/HomePage/homepage';
import CalculatorDashboard from './pages/Calculators/CalculatorDashboard';
import FindALoanOfficer from './components/lopage/FindALoanOfficer';
import BranchPage from './pages/Branch/Branch';
import LoanOfficerProfile from './pages/Agents/LoanOfficerProfile';
import Blog from './pages/Blog/Blog';
import ViewBlogPost from './pages/Blog/View';
import PrivacyPolicyPage from './pages/legal/privacyPolicy';
import LegalDisclosuresPage from './pages/legal/legalAndLicensing';
import SecurityStatementPage from './pages/legal/securityStatement';
import TermsOfUsePage from './pages/legal/termsOfUse';
import DataPartnersPage from './pages/legal/dataPartners';
import BranchBusinessProfilesPage from './pages/business/businessProfiles';
import CareersPage from './pages/business/career';
import CaliforniaPrivacyPolicyPage from './pages/legal/ccpa';
import PaymentsLandingPage from './pages/payments/paymentsLandingPage';
import ContactUsPage from './pages/contactus/contactUs';
import BlogLandingCategories from './pages/Blog/blogLandingPage';
import IntakeFormDynamic from './pages/BuilderIntake/IntakeFormDynamic';
import SlugRouter from './components/slugrouter/slugrouter';
import LoanProgramsPage from './pages/LoanPrograms/LoanProgram';
import PurchasePage from './pages/Purchase/purchase';
import RefinancePage from './pages/refinance/refinance';
import OptOutPage from './pages/OptOut/optOut';
import BorrowerRegisterPage from './pages/BorrowerRegisterPage';
import BorrowerLoginPage from './pages/BorrowerLoginPage';
// Loan-program page components are loaded by SlugRouter (top-level slugs).
// They are no longer imported here directly.
import StateProfile from './pages/states/View';
import GroupPage from './pages/Groups/GroupPage';
import GetStartedPage from './pages/BuilderIntake/GetStarted';
import BorrowerLoanDetail from './pages/Borrower/BorrowerLoanDetail';
import BorrowerLoans from './pages/Borrower/BorrowerLoans';
import BorrowerLoanTimeline from './pages/Borrower/BorrowerLoanTimeline';
import BorrowerMortgageCalculator from './pages/Borrower/BorrowerMortgageCalculator';
import BorrowerProtectedRoute from "./components/borrower/BorrowerProtectedRoute";
import BorrowerLayout from './layouts/borrower/BorrowerLayout';

// ----------------------------------------------------------------------

export default function App() {

  const token = localStorage.getItem('token');

  // eslint-disable-next-line react-hooks/exhaustive-deps, prefer-const
 const user = JSON.parse(localStorage.getItem('user'))
  useNavigate()

  return (
    <ThemeProvider>
      <ScrollToTop />
      <PageMetaSync />
      <AnalyticsRouteGuard />
      <StyledChart />
      <ToastContainer />
      {token && user?.role ? (
        user?.role === 'admin' || user?.role === 'marketing' ? <Routers /> : user?.role === 'user' || user?.role === 'borrower' ? <UserRoutes /> : undefined
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/borrower/login" element={<BorrowerLoginPage />} />
           <Route
  path="/borrower/loans"
  element={
    <BorrowerProtectedRoute>
      <BorrowerLoans />
    </BorrowerProtectedRoute>
  }
/>

<Route
  path="/borrower/loan/:loanId"
  element={
    <BorrowerProtectedRoute>
      <BorrowerLayout />
    </BorrowerProtectedRoute>
  }
>
  <Route index element={<Navigate to="tasks" replace />} />
  <Route path="tasks" element={<BorrowerLoanDetail />} />
  <Route path="status" element={<BorrowerLoanTimeline />} />
  <Route path="calculator" element={<BorrowerMortgageCalculator />} />
</Route>
           <Route path="/loan-programs" element={<LoanProgramsPage />} />
            {/* Redirect legacy /loan-programs/{slug} URLs to new top-level slugs.
                The actual program pages are now resolved by SlugRouter at /:slug. */}
            <Route path="/loan-programs/conventional" element={<Navigate to="/conventional" replace />} />
            <Route path="/loan-programs/va" element={<Navigate to="/va" replace />} />
            <Route path="/loan-programs/fha" element={<Navigate to="/fha" replace />} />
            <Route path="/loan-programs/FHA" element={<Navigate to="/fha" replace />} />
            <Route path="/loan-programs/usda" element={<Navigate to="/usda" replace />} />
            <Route path="/loan-programs/refinancing" element={<Navigate to="/refinancing" replace />} />
            <Route path="/loan-programs/jumbo" element={<Navigate to="/jumbo" replace />} />
            <Route path="/loan-programs/first-time-homebuyers" element={<Navigate to="/first-time-homebuyers" replace />} />
            <Route path="/loan-programs/low-down-payment" element={<Navigate to="/low-down-payment" replace />} />
            <Route path="/loan-programs/dscr" element={<Navigate to="/dscr" replace />} />
            {/* Legacy shortcut redirects — re-aimed at the new canonical URLs. */}
            <Route path="/refi" element={<Navigate to="/refinancing" replace />} />
            <Route path="/va-loans" element={<Navigate to="/va" replace />} />
            <Route path="/fha-loans" element={<Navigate to="/fha" replace />} />
            <Route path="/jumbo-loans" element={<Navigate to="/jumbo" replace />} />
            <Route path="/usda-loans" element={<Navigate to="/usda" replace />} />
    <Route path="/purchase" element={<PurchasePage />} />
       <Route path="/refinance" element={<RefinancePage />} />
          <Route path="/blog" element={<BlogLandingCategories />} />
          <Route path="/blog/:id" element={<ViewBlogPost />} />
          <Route path="/blog/category/:category?" element={<Blog />} />
          <Route path="/submit-payment" element={<PaymentsLandingPage />} />
         <Route path="/contact" element={<ContactUsPage/>} />
          <Route path="/opt-out" element={<OptOutPage/>} />
          <Route path="/blog/post/:id" element={<ViewBlogPost/>} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/borrower" element={<BorrowerRegisterPage />} />
          <Route path="/landingpage" element={<LandingPage />} />
          <Route path="/home" element={<HomePage />} />
           <Route path="/coventry-homes" element={<HomePage />} />
             <Route path="/crescent-homes" element={<HomePage />} />
          <Route path="/exclusiveleads" element={<ExclusiveLeadsPage />} />
          <Route path="/consumerengagement" element={<ConsumerEngagementPage />} />
          <Route path="/clientacquisition" element={<ClientAcquisitionPage />} />
          <Route path="/portfolioretention" element={<PortfolioRetentionPage />} />
          <Route path="/branchlocations" element={<BranchLocations />} />
      
          <Route path="/calculators" element={<CalculatorDashboard />} />
          <Route path="/find-a-loan-officer" element={<FindALoanOfficer />} />
          <Route path="/branch/:branchName" element={<BranchPage />} />
          <Route path="/state/:id" element={<StateProfile />} />
       
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/getstarted" element={<GetStartedPage />} />
          <Route path="/licensing" element={<LegalDisclosuresPage />} />
           <Route path="/security" element={<SecurityStatementPage />} />
           <Route path="/terms" element={<TermsOfUsePage />} />
           <Route path="/ccpa" element={<CaliforniaPrivacyPolicyPage />} />
              <Route path="/data-partners" element={<DataPartnersPage />} />
                <Route path="/business-profiles" element={<BranchBusinessProfilesPage />} />
                <Route path="/team-jet" element={<CareersPage />} /> 
                  <Route path="/:slug" element={<SlugRouter />} />
                   <Route path="/group/:groupSlug" element={<GroupPage />} />
          <Route path="*" element={<Navigate to="/home" />} />

        </Routes>
      )}
    </ThemeProvider>
  );
}
